module.exports = __webpack_public_path__ + "static/media/pira_hot.1d014670.webp";